import * as React from 'react';
import ouiDom from '@goldwasserexchange/oui-dom';
import { Trans } from '@lingui/macro';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useAtomValue } from 'jotai';
import { pathnameUrlLanguageAtom, ValidSections } from '../../../../../../../../../../../../../../../../../../../../../../history';
import { useBondSAccId, useBondsBondSlug } from '../../../../../../../../../../../../../../../../../../../../../../actor/api/Services/bonds';

export const SideBarSeeMoreButton = () => {
  const locale = useAtomValue(pathnameUrlLanguageAtom);
  const sAccId = useBondSAccId();
  const {
    data: slug,
  } = useBondsBondSlug();
  return (
    <ouiDom.A.AButton
      to={`/${locale}/${ValidSections.BONDS}/details/${slug ?? sAccId}`}
      backgroundColor={ouiStyle.Constants.Colors.accent}
      color={ouiStyle.Constants.Colors.inverted}
      hoverBackgroundColor={ouiStyle.Constants.Colors.accent}
      borderColor={ouiStyle.Constants.Colors.accent}
      lineFactor={1}
    >
      <Trans>
        Plus d'infos
      </Trans>
    </ouiDom.A.AButton>
  );
};
